class Performance {
    constructor(data = {}) {
      this.id = data.id || data._id || null;
      this._id = data._id || data.id || null;
      this.employeeId = data.employeeId || null;
      this.reviewPeriod = data.reviewPeriod || '';
      this.reviewDate = data.reviewDate || new Date().toISOString().split('T')[0];
      this.reviewerId = data.reviewerId || null;
      this.overallRating = data.overallRating || 0;
      this.technicalSkills = data.technicalSkills || 0;
      this.communication = data.communication || 0;
      this.teamwork = data.teamwork || 0;
      this.leadership = data.leadership || 0;
      this.punctuality = data.punctuality || 0;
      this.strengths = data.strengths || '';
      this.areasOfImprovement = data.areasOfImprovement || '';
      this.goals = data.goals || '';
      this.comments = data.comments || '';
      this.status = data.status || 'Draft';
      this.createdAt = data.createdAt || new Date().toISOString();
    }
  
    getStatusColor() {
      const colors = { 'Draft': '#6b7280', 'Submitted': '#f59e0b', 'Completed': '#10b981' };
      return colors[this.status] || '#6b7280';
    }
  
    getRatingColor() {
      if (this.overallRating >= 4) return '#10b981';
      if (this.overallRating >= 3) return '#f59e0b';
      return '#ef4444';
    }
  
    validate() {
      const errors = [];
      if (!this.employeeId) errors.push('Employee is required');
      if (!this.reviewPeriod) errors.push('Review period is required');
      if (!this.reviewerId) errors.push('Reviewer is required');
      if (this.overallRating < 0 || this.overallRating > 5) errors.push('Rating must be between 0 and 5');
      return { isValid: errors.length === 0, errors };
    }
  
    toJSON() { return { ...this }; }
    static fromJSON(json) { return new Performance(json); }
  }
  export default Performance;